<script>
import { Doughnut, mixins } from "vue-chartjs";
// import ChartDataLabels from "chartjs-plugin-datalabels";
const { reactiveProp } = mixins;

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ["chartData", "options", "styles"],
  watch: {
    chartData() {
      this.$data._chart.update();
    }
  },
  mounted() {
    this.renderChart(this.chartdata, this.options);
  }
};
</script>
